var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-search",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#212529",
    fillRule: "nonzero",
    id: "\\uF002"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.875,14.65625 C16.0625,14.8229167 16.0625,15 15.875,15.1875 L15.1875,15.875 C15,16.0625 14.8229167,16.0625 14.65625,15.875 L10.875,12.09375 C10.7916667,12.0104167 10.75,11.9270833 10.75,11.84375 L10.75,11.40625 C9.52083333,12.46875 8.10416667,13 6.5,13 C4.70833333,13 3.17708333,12.3645833 1.90625,11.09375 C0.635416667,9.82291667 0,8.29166667 0,6.5 C0,4.70833333 0.635416667,3.17708333 1.90625,1.90625 C3.17708333,0.635416667 4.70833333,0 6.5,0 C8.29166667,0 9.82291667,0.635416667 11.09375,1.90625 C12.3645833,3.17708333 13,4.70833333 13,6.5 C13,8.10416667 12.46875,9.52083333 11.40625,10.75 L11.84375,10.75 C11.9479167,10.75 12.03125,10.7916667 12.09375,10.875 L15.875,14.65625 Z M2.96875,10.03125 C3.94791667,11.0104167 5.125,11.5 6.5,11.5 C7.875,11.5 9.05208333,11.0104167 10.03125,10.03125 C11.0104167,9.05208333 11.5,7.875 11.5,6.5 C11.5,5.125 11.0104167,3.94791667 10.03125,2.96875 C9.05208333,1.98958333 7.875,1.5 6.5,1.5 C5.125,1.5 3.94791667,1.98958333 2.96875,2.96875 C1.98958333,3.94791667 1.5,5.125 1.5,6.5 C1.5,7.875 1.98958333,9.05208333 2.96875,10.03125 Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon-search.96b771b43bcb6f2d7b8be9283ce053da.svg";
export { ForwardRef as ReactComponent };